<template>
  <div class="grid grid-cols-1 gap-4 w-full shrink-0">
    <div class="grid grid-cols-2 gap-4">
      <UFormField label="Nome" name="name" size="lg" :error="r$.name?.$error ? r$.name.$errors?.[0] : undefined">
        <UInput v-model="state.name" placeholder="Ex: João" class="w-full" size="lg" data-cy="register-name-input"
          :color="r$.name?.$dirty ? (r$.name.$correct ? 'success' : 'error') : 'neutral'"
          @blur="r$.name?.$touch()">
          <template #trailing>
            <UIcon v-if="r$.name?.$correct" name="i-lucide-check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
          </template>
        </UInput>
      </UFormField>
      <UFormField label="Sobrenome" name="surname" size="lg" :error="r$.surname?.$error ? r$.surname.$errors?.[0] : undefined">
        <UInput v-model="state.surname" placeholder="Ex: Silva" class="w-full" size="lg" data-cy="register-surname-input"
          :color="r$.surname?.$dirty ? (r$.surname.$correct ? 'success' : 'error') : 'neutral'"
          @blur="r$.surname?.$touch()">
          <template #trailing>
            <UIcon v-if="r$.surname?.$correct" name="i-lucide-check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
          </template>
        </UInput>
      </UFormField>
    </div>

    <UFormField label="Data de Nascimento" name="birthDate" size="lg" :error="r$.birthDate?.$error ? r$.birthDate.$errors?.[0] : undefined">
      <UInput v-model="state.birthDate" v-maska="'##/##/####'" placeholder="DD/MM/AAAA" class="w-full" size="lg"
        :color="r$.birthDate?.$dirty ? (r$.birthDate.$correct ? 'success' : 'error') : 'neutral'" data-cy="register-birthDate-input"
        @blur="r$.birthDate?.$touch()">
        <template #trailing>
          <UIcon v-if="r$.birthDate?.$correct" name="i-lucide-check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
        </template>
      </UInput>
    </UFormField>

    <UFormField label="Você é aluno de curso regular do IFMG?" name="isStudent" size="lg" :error="r$.isStudent?.$error ? r$.isStudent.$errors?.[0] : undefined">
      <USelect v-model="state.isStudent" :items="['Sim', 'Não']" placeholder="Escolher..." class="w-full" size="lg"
        :color="r$.isStudent?.$dirty ? (r$.isStudent.$correct ? 'success' : 'error') : 'neutral'" data-cy="register-isStudent-select"
        @blur="r$.isStudent?.$touch()">
        <template #trailing>
          <UIcon v-if="r$.isStudent?.$correct" name="i-lucide-check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
        </template>
      </USelect>
    </UFormField>

    <UFormField label="Como você conheceu o IFMG?" name="howMeet" size="lg" :error="r$.howMeet?.$error ? r$.howMeet.$errors?.[0] : undefined">
      <USelect v-model="state.howMeet" :items="['Redes Sociais', 'Amigos']" placeholder="Escolher..." class="w-full" size="lg"
        :color="r$.howMeet?.$dirty ? (r$.howMeet.$correct ? 'success' : 'error') : 'neutral'" data-cy="register-howMeet-select"
        @blur="r$.howMeet?.$touch()">
        <template #trailing>
          <UIcon v-if="r$.howMeet?.$correct" name="i-lucide-check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
        </template>
      </USelect>
    </UFormField>
  </div>
</template>

<script setup lang="ts">
import { vMaska } from 'maska/vue'

const store = useRegisterStore()
const state = store.state

const { r$ } = useRegleSchema(state as any, step1Schema, { autoDirty: true })

defineExpose({
  validate: async () => await r$.$validate(),
  reset: () => r$.$reset()
})
</script>